_setUserAccountCancelSubscriptionConfirmThunk